import {
  ADMIN,
  ADMINISTRATIVE,
  ADMINISTRATOR,
  COACH,
  FRONTDESK,
  StaffRole,
  SUPERUSER,
} from "../types/roles";

type RouteSecurity = {
  path: string;
  roles: StaffRole[];
};

const ALL_STAFF_ROLES: StaffRole[] = [
  ADMINISTRATIVE,
  FRONTDESK,
  COACH,
  ADMINISTRATOR,
  ADMIN,
  SUPERUSER,
];

// Superusers are generally created with the role of coach in the client_users table.
// If superusers should have access to something, make sure to check the `superuser`
// property and not the `role` property. The `superuser` property is derived from the users table.
const ADMIN_LEVEL_ROLES: StaffRole[] = [ADMINISTRATOR, ADMIN, SUPERUSER];

const routes: RouteSecurity[] = [
  {
    path: "/invoices",
    roles: ALL_STAFF_ROLES,
  },
  {
    path: "/reports/transactions",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/reports/payments",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/reports/deposits",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/reporting/engagement",
    roles: ALL_STAFF_ROLES,
  },
  {
    path: "/reporting",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/reports/deposits",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/reports/retail",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/members/expiring",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/members/risk",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/no-show",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/reports/churn",
    roles: ADMIN_LEVEL_ROLES,
  },
  {
    path: "/account",
    roles: ADMIN_LEVEL_ROLES,
  },
];

export default routes;
